// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"159":"4e18bb68","437":"f19ae65d","950":"d6ea17a9"}[chunkId] + ".js";
};